/**
 * Check win conditions. Returns a winner string or null (game continues).
 * Winners: "village" | "werewolf" | "lovers" | "flute_player" | "white_werewolf" | "angel" | "nobody"
 */
export function checkWinCondition(players) {
  const alive = players.filter(p => p.alive);
  if (alive.length === 0) return "nobody";

  // ── White Werewolf solo win ────────────────────────────────────────
  const ww = alive.find(p => p.baseRoleId === "white_werewolf");
  if (ww) {
    if (alive.length === 1) return "white_werewolf";
    if (alive.length === 2) {
      // 1v1: WW wins unless WW is already charmed (Flute Player wins instead)
      if (!ww.statuses.includes("charmed")) return "white_werewolf";
    }
  }

  // ── Flute Player win: all non-FP alive players are charmed ─────────
  const fp = alive.find(p => p.baseRoleId === "flute_player");
  if (fp) {
    const others = alive.filter(p => p.id !== fp.id);
    if (others.length > 0 && others.every(p => p.statuses.includes("charmed"))) {
      return "flute_player";
    }
  }

  // ── Lovers win: only 2 remain and both are lovers ──────────────────
  const lovers = alive.filter(p => p.statuses.includes("lover"));
  if (alive.length === 2 && lovers.length === 2) return "lovers";

  // ── Camp wins — exclude solo roles (WW, FP) from balance ──────────
  const campAlive = alive.filter(p =>
    p.baseRoleId !== "white_werewolf" && p.baseRoleId !== "flute_player"
  );
  const wolves    = campAlive.filter(p => p.effectiveAlignment === "werewolf");
  const nonWolves = campAlive.filter(p => p.effectiveAlignment !== "werewolf");

  // Werewolves win: wolves ≥ non-wolf camp players; WW presence blocks this
  if (wolves.length > 0 && wolves.length >= nonWolves.length) {
    if (ww) return null; // WW may betray them later
    return "werewolf";
  }

  // Village wins: no wolves AND no WW AND village-aligned players exist
  if (wolves.length === 0 && !ww) {
    const hasVillage = campAlive.some(p => p.effectiveAlignment === "village");
    if (!hasVillage) return null; // Only solo roles remain — game continues
    return "village";
  }

  return null;
}
